/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Primarystudyinterest_Study_Primary_School_Teaching28Inputs */

const en__field__enum_primarystudyinterest_study_primary_school_teaching28 = /** @type {(inputs: _Field__Enum_Primarystudyinterest_Study_Primary_School_Teaching28Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primary School Teaching`)
};

const de__field__enum_primarystudyinterest_study_primary_school_teaching28 = /** @type {(inputs: _Field__Enum_Primarystudyinterest_Study_Primary_School_Teaching28Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lehramt für Grundschulen`)
};

/**
* | output |
* | --- |
* | "Primary School Teaching" |
*
* @param {_Field__Enum_Primarystudyinterest_Study_Primary_School_Teaching28Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_primarystudyinterest_study_primary_school_teaching28 = /** @type {((inputs?: _Field__Enum_Primarystudyinterest_Study_Primary_School_Teaching28Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Primarystudyinterest_Study_Primary_School_Teaching28Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_primarystudyinterest_study_primary_school_teaching28(inputs)
	return de__field__enum_primarystudyinterest_study_primary_school_teaching28(inputs)
});
export { _field__enum_primarystudyinterest_study_primary_school_teaching28 as "_field__enum_primaryStudyInterest_STUDY_PRIMARY_SCHOOL_TEACHING" }